import { motion } from "framer-motion";
import {
  headingVariants,
  fadeInVariants,
  viewportSettings,
} from "../../shared/utils/animations";
import styles from "./get-in-touch.module.scss";

const GetInTouch = () => {
  const BOOKING_URL = `https://www.vagaro.com/lawameraki/book-now`;

  return (
    <>
      <div className={styles["container"]}>
        <motion.div
          initial="headingOffScreen"
          whileInView="headingOnScreen"
          viewport={viewportSettings}
          variants={headingVariants}
        >
          <h1>Get In Touch</h1>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p>
            Let us bring your hair goals to life and leave you feeling
            confident, beautiful, and completely satisfied. Contact us now for
            an unforgettable hair experience.
          </p>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <div className={styles["send-email-group"]}>
            {/* <input type="email" placeholder="Email Address" /> */}
            <button
              onClick={() => {
                window.open(BOOKING_URL, "_blank");
              }}
            >
              Book
            </button>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default GetInTouch;
